import React from "react";

// Reusable device frame so every app screenshot uses the same phone mockup.
// Screenshots already include the iOS status bar + dynamic island, so no notch overlay.
export const PhoneFrame = ({ src, alt, className = "", testId, buttons = true }) => (
  <div
    className={`relative rounded-[2.6rem] bg-[#0d0f0e] p-[8px] shadow-[0_30px_65px_rgba(47,94,67,0.28)] ring-1 ring-black/5 ${className}`}
  >
    {buttons && (
      <>
        <div className="absolute -left-[3px] top-[22%] h-[12%] w-[3px] rounded-l-md bg-[#0d0f0e]" />
        <div className="absolute -right-[3px] top-[16%] h-[7%] w-[3px] rounded-r-md bg-[#0d0f0e]" />
        <div className="absolute -right-[3px] top-[26%] h-[12%] w-[3px] rounded-r-md bg-[#0d0f0e]" />
      </>
    )}
    <div className="overflow-hidden rounded-[2.1rem] bg-white">
      <img src={src} alt={alt} className="block w-full" data-testid={testId} />
    </div>
  </div>
);
